export default __webpack_public_path__ + "static/media/emptyStar.dd9c5d5a.svg";